import { useCallback, useEffect, useRef, useState } from 'react'

export function useMediaQuery(query) {
  const [state, setState] = useState(window.matchMedia(query).matches)

  const mounted = useRef(true)
  const mql = useRef(null)

  const mediaQueryChange = useCallback(() => {
    if (!mounted.current) return
    setState(!!mql.current?.matches)
  }, [])

  useEffect(() => {
    mounted.current = true
    mql.current = window.matchMedia(query)

    mql.current.addListener(mediaQueryChange)
    setState(mql.current.matches)

    return () => {
      mounted.current = false
      mql.current?.removeListener(mediaQueryChange)
    }
  }, [query, mediaQueryChange])

  return state
}

export function useIsMobile() {
  const isMobile = useMediaQuery('(min-width: 320px) and (max-width: 639px)')
  return isMobile
}
